import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';

import { green, grey, orange, red } from '@mui/material/colors';

import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PauseIcon from '@mui/icons-material/Pause';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { ReclamationStatut } from 'constants.js';

// TODO Theme !
const styles = {
    statut0: {
        color: red[500]
    },

    statut1: {
        color: green[500]
    },

    statut2: {
        color: orange[500]
    },

    statut3: {
        color: grey[500]
    },

    statut4: {
        color: grey[500]
    }
};

class ReclamationStatutIcon extends React.Component {
    render() {
        const { statut, classes } = this.props;

        switch (statut) {
            case ReclamationStatut.Ouvert: return (<Tooltip title="Ouvert"><AssignmentIcon className={classes.statut0} /></Tooltip>);
            case ReclamationStatut.EnCours: return (<Tooltip title="En cours"><AssignmentIndIcon className={classes.statut1} /></Tooltip>);
            case ReclamationStatut.Reaffecte: return (<Tooltip title="Réafecté"><PauseIcon className={classes.statut2} /></Tooltip>);
            case ReclamationStatut.ClotureClient: return (<Tooltip title="Clôture client"><AssignmentTurnedInIcon className={classes.statut3} /></Tooltip>);
            case ReclamationStatut.ClotureDefinitive: return (<Tooltip title="Clôture définitive"><AssignmentTurnedInIcon className={classes.statut4} /></Tooltip>);

            default: return null;
        }
    }
}

ReclamationStatutIcon.propTypes = {
    statut: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReclamationStatutIcon);